import React from 'react';
import { CircleDashed } from 'lucide-react';

const LoadingSpinner = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen bg-gray-50 dark:bg-gray-900 text-gray-500 dark:text-gray-400">
            <CircleDashed className="w-12 h-12 animate-spin mb-4 text-blue-600" />
            <p className="text-sm font-medium animate-pulse">Carregando...</p>
        </div>
    );
};

export default LoadingSpinner;
